import connectedAuthWrapper from 'redux-auth-wrapper/connectedAuthWrapper';
import { connectedReduxRedirect } from 'redux-auth-wrapper/history4/redirect';
import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper';
import { push, replace } from 'connected-react-router';

const locationHelper = locationHelperBuilder({});

export const noRequireAuth = connectedReduxRedirect({
  redirectPath: (state, ownProps) =>{
    console.log(state)
    if(state.shift.auth.status === "PENDING" || state.shift.auth.status === "PENDING_EULA_ACCEPTANCE"){
      return locationHelper.getRedirectQueryParam(ownProps) || '/en-CA/changepassword';
    }else{
      return locationHelper.getRedirectQueryParam(ownProps) || '/en-CA/';
    }
  },

  allowRedirectBack: false,
  authenticatedSelector: state => !state.shift.auth.authenticated,
  wrapperDisplayName: 'UserIsNotAuthenticated',
  redirectAction: push
});

export const requireAuth = connectedReduxRedirect({
  redirectPath: (state, ownProps) =>{
    console.log(state)

    if(state.shift.auth.status === "PENDING" || state.shift.auth.status === "PENDING_EULA_ACCEPTANCE"){
      console.log(state.shift.auth.status)
      console.log( state.router.location)
      if(state.router.location.pathname !== "/en-CA/changepassword"){
        window.location.href = "/en-CA/changepassword";
      }else{
        return locationHelper.getRedirectQueryParam(ownProps) || '/en-CA/changepassword';
      }
    }else{
      return locationHelper.getRedirectQueryParam(ownProps) || '/en-CA/login';
    }
  },

  // redirectPath: '/en-CA/login',
  allowRedirectBack: false,
  authenticatedSelector: state => state.shift.auth.authenticated,
  wrapperDisplayName: 'UserIsAuthenticated',
  redirectAction: push
});

export const requireAuthBack = connectedReduxRedirect({
  redirectPath: '/en-CA/login',
  allowRedirectBack: true,
  authenticatedSelector: state => state.shift.auth.authenticated,
  wrapperDisplayName: 'UserIsAuthenticated',
  redirectAction: push
});

export const hideWithoutAuth = connectedAuthWrapper({
  authenticatedSelector: state => state.shift.auth.authenticated,
  wrapperDisplayName: 'VisibleOnlyLoggedIn'
});

export const requireOperation = connectedReduxRedirect({
  redirectPath: '/en-CA/404',
  allowRedirectBack: false,
  authenticatedSelector: state => state.shift.status.payload != null,
  wrapperDisplayName: 'UserIsOperated',
  redirectAction: push
});



// WEBPACK FOOTER //
// ./src/components/HOC/auth.js